module.exports = require("./fr-KM.js");